import React from 'react'

import blog2 from '../../../images/blogs/2.png'

import banner from '../../../images/banners/login.jpg'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
export default function GlobalReach() {
  return (
    <div>
      <Helmet>
        <title>Shypv | Articles</title>
      </Helmet>
      <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <div className="container"><div className="row">
          <div className="col-md-12 col-sm-12 your_business text-center">
            <div className="business_content">
              <h2>Global Reach</h2>

            </div>
          </div>
        </div>
        </div>
      </section>
      <div className="pages_content blogmain">
        <div className="container">
          <div className="row">
            <div id="primary" className="content-area" style={{ float: 'left', width: '100%' }}>
              <main id="main" className="site-main" role="main">
                <div className="entry-content">
                  <div className="become_driver">
                    <div className="row">
                      <div className="container-fluid py-5">
                        <div className="container">
                          <div className="text-center mx-auto mb-5" >
                            <img src={blog2} style={{ width: '100%' }} />
                          </div>
                          <div className="row ">
                            <div className="col-md-12">
                              <div className="bg-light rounded overflow-hidden">
                                <h4>Accessing New Markets for Growth</h4>
                                <p>Here are a few tips on expanding your business into UAE, Saudi Arabia, Bahrain, Kuwait, and Qatar. UAE DAFZA acts as free zone hub for all the region, by shipping in bulk to the UAE you can deconsolidate and re-dispatch express to the final country destinations; Shypv can act as your importer of record (IOR) in the UAE and as a gateway into the rest of GCC.</p>

                                <div className="row">
                                  <div className="col-md-6">
                                    <h5>Emerging Market Access</h5>
                                    <ul>

                                      <li>Global supply chains velocity and complexity are pushing US and EU companies to re-evaluate their distribution models to reach new markets.</li>
                                      <li>SHYPV’s strategic location in Dubai provides access to over 4 bi people in the GCC, India, and Africa. We offer courier express services, local warehousing, transportation, distribution, and brokerage resources to simplify the challenges of international expansion.</li>
                                    </ul>

                                    <h5>Asset-Light Scalability</h5>
                                    <ul>
                                      <li>Help customers reduce cost and capital investment through multi-client logistics facilities that allow them to reduce supply chain costs by staging goods in Free Trade areas like the UAE, providing enhanced customer experience through hub and spoke model serving into new markets.</li>
                                    </ul>
                                    <h5>Trusted SHYPV Brand</h5>
                                    <ul>
                                      <li>Customers receive the same international shipments quality, reliable, guaranteed service they are accustomed to in other parts of the world.</li>
                                    </ul>
                                  </div>

                                  <div className="col-md-6">
                                    <h5>Sophisticated Technology</h5>
                                    <ul>
                                      <li>GPowerful and secure global SHYPV IT platforms provide customers the visibility and reporting parcel delivery options.</li>
                                    </ul>

                                    <h5>Expertise & Reliability</h5>
                                    <ul>
                                      <li>Integrated customer solutions with fast transit time designed by Shypv including reverse logistics, repairs on site, warranty handling, LTL and FTL transportation, distribution, trade management, and value-added services create a single point of contact across the supply chain, streamlining operations to give your customers peace of mind when expanding into the region.</li>
                                    </ul>
                                    <h5>SHYPV Compliance</h5>
                                    <ul>
                                      <li>Consistent and strict adherence to global end-to-end processes, auditing and trade regulations allow customers to expand with confidence, into unknown territories, removing compliance risk.</li>
                                    </ul>
                                  </div>

                                </div>





                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
